var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":'E-mail',"prepend-icon":"mdi-mail","type":"email"},on:{"input":function($event){return _vm.$emit('input',_vm.val)}},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})}
var staticRenderFns = []

export { render, staticRenderFns }